import { ImageOff } from "lucide-react";
import { getProductIcon } from "@/lib/returns";

export default function ProductVisual({ item, evidence = null, size = "normal" }) {
  if (evidence?.dataUrl) {
    return (
      <img
        className={`product-visual product-visual-${size} product-photo`}
        src={evidence.dataUrl}
        alt={`${item.product_name} inspection evidence`}
        data-testid={`damage-photo-${item.order_id}`}
      />
    );
  }

  if (evidence) {
    return (
      <div
        className={`product-visual product-visual-${size} evidence-placeholder`}
        role="img"
        aria-label={`${evidence.label || "Damage"} photograph`}
        data-testid={`damage-photo-${item.order_id}`}
      >
        <ImageOff size={size === "small" ? 20 : 30} aria-hidden="true" />
        <span>{evidence.label || "Damage evidence"}</span>
      </div>
    );
  }

  return (
    <div
      className={`product-visual product-visual-${size} product-placeholder category-${item.category}`}
      role="img"
      aria-label={`${item.product_name} catalog image`}
      data-testid={`catalog-image-${item.order_id}`}
    >
      {getProductIcon(item.category, "product-icon")}
      <span>Catalog item</span>
    </div>
  );
}